import { api } from "api";

export const haveSSO = (username, onBegin, onSuccess, onError) => {
  return async () => {
    onBegin();
    await api
      .post("/api/auth/have-sso", {
        username,
      })
      .then(async (res) => {
        onSuccess(res.data.data);
      })
      .catch((e) => {
        onError(e);
      });
  };
};

export const authenticate = (
  username,
  password,
  emailcode,
  captchaToken,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(
        "/api/auth/login",
        {
          username,
          password,
          emailcode
        },
        {
          headers: {
            "captcha-token": captchaToken,
          },
        }
      )
      .then(async (res) => {
        const dispatchObj = {
          type: "LOGIN_SUCCESS",
          payload: res.data.data,
        };

        dispatch(dispatchObj);
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("expiration", res.data.data.expiration);
        localStorage.setItem("refreshToken", res.data.data.refreshToken);
        localStorage.setItem(
          "refreshTokenExpiration",
          res.data.data.refreshTokenExpiration
        );
        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "LOGIN_ERROR",
        });
        localStorage.removeItem("token");
        onError(e);
      });
  };
};

export const sso = (code, state, sessionState, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/auth/sso", {
        code,
        state,
        sessionState,
      })
      .then(async (res) => {
        const dispatchObj = {
          type: "LOGIN_SUCCESS",
          payload: res.data.data,
        };

        dispatch(dispatchObj);
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("expiration", res.data.data.expiration);
        localStorage.setItem("refreshToken", res.data.data.refreshToken);
        localStorage.setItem(
          "refreshTokenExpiration",
          res.data.data.refreshTokenExpiration
        );
        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "LOGIN_ERROR",
        });
        localStorage.removeItem("token");
        onError(e);
      });
  };
};

export const refreshToken = (refreshToken, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/auth/refresh-token-login", {
        refreshToken,
      })
      .then(async (res) => {
        // dispatch({
        //   type: "LOGIN_SUCCESS",
        //   payload: res.data.data,
        // });
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("expiration", res.data.data.expiration);
        localStorage.setItem("refreshToken", res.data.data.refreshToken);
        localStorage.setItem(
          "refreshTokenExpiration",
          res.data.data.refreshTokenExpiration
        );
        onSuccess();
        // Renew Local Storage
      })
      .catch((e) => {
        dispatch({
          type: "LOGIN_ERROR",
        });
        localStorage.removeItem("token");
        localStorage.removeItem("expiration");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("refreshTokenExpiration");
        onError(e);
      });
  };
};

export const getCompanies = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/auth/get-companies")
      .then(async (res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        onError(e);
      });
  };
};

export const setCompany = (companyId, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(`/api/auth/set-company/${companyId}`)
      .then(async (res) => {
        const dispatchObj = {
          type: "LOGIN_SUCCESS",
          payload: res.data.data,
        };
        dispatch(dispatchObj);
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("expiration", res.data.data.expiration);
        localStorage.setItem("refreshToken", res.data.data.refreshToken);
        localStorage.setItem(
          "refreshTokenExpiration",
          res.data.data.refreshTokenExpiration
        );
        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "LOGIN_ERROR",
        });
        localStorage.removeItem("token");
        onError(e);
      });
  };
};

export const setAuth = (
  token,
  expiration,
  refreshToken,
  refreshTokenExpiration
) => {
  return {
    type: "LOGIN_SUCCESS",
    payload: {
      token,
      expiration,
      refreshToken,
      refreshTokenExpiration,
    },
  };
};

export const logOut = () => {
  let lang = localStorage.getItem("i18nextLng");
  localStorage.clear();
  localStorage.setItem("i18nextLng", lang);
  return { type: "LOGOUT_SUCCESS" };
};
